<template>
  <div v-if="false" />
</template>

<script setup lang="ts">
import { inject } from 'vue';

defineOptions({ name: 'GoogleMapFetcherFi' });

const emit = defineEmits<{
  (e: 'map', map: any): void;
}>();

const mapPromise = inject<Promise<any>>('$mapPromise');

// created
(async () => {
  const map = await mapPromise;
  emit('map', map);
})();
</script>
